module.exports = __webpack_public_path__ + "static/img/3618_phase_function_Paper_PointsHejduk_Prediction.fe266be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3618_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jQqB
// module chunks = 0